export default __webpack_public_path__ + "static/media/Armbands of the Inconceivable.d22f2474.jpg";